const WHATSAPP_URL = 'https://wa.me/5516981106759?text=Ol%C3%A1%2C%20preciso%20de%20ajuda%20jur%C3%ADdica%20urgente';

export default function WhatsAppButton() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-8 right-8 z-50 w-16 h-16 flex items-center justify-center rounded-full cursor-pointer transition-all duration-300 hover:scale-110"
      style={{
        background: 'linear-gradient(135deg,#C9A24A,#E1C67A)',
        boxShadow: '0 8px 28px rgba(201,162,74,0.5)',
        animation: 'waPulse 2.5s ease-in-out infinite',
      }}
      aria-label="Falar no WhatsApp"
    >
      <i className="ri-whatsapp-line text-3xl" style={{ color: '#0B2F5B' }} />

      <style>{`
        @keyframes waPulse {
          0%, 100% { transform: scale(1); box-shadow: 0 8px 28px rgba(201,162,74,0.5); }
          50% { transform: scale(1.08); box-shadow: 0 12px 40px rgba(201,162,74,0.65); }
        }
      `}</style>
    </a>
  );
}